import { render, staticRenderFns } from "./value-assessment.vue?vue&type=template&id=a420fbbc&scoped=true&"
import script from "./value-assessment.vue?vue&type=script&lang=js&"
export * from "./value-assessment.vue?vue&type=script&lang=js&"
import style0 from "./value-assessment.vue?vue&type=style&index=0&id=a420fbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a420fbbc",
  null
  
)

export default component.exports